module.exports = __webpack_public_path__ + "static/media/modi.1068a7f2.png";